module.exports = __webpack_public_path__ + "static/media/1019811.08dd3c36.jpg";